import { useTranslation } from "react-i18next";
import Card from "@components/ui/Card/Card";
import ProductService from "@services/ProductService";
import { useEffect, useState } from "react";
import Version from "@ltypes/version";
import { FaTag } from "react-icons/fa6";
import './ChangeLogPage.scss';
import Badge from "@components/ui/Badge/Badge";
import DateHelper from "@helpers/DateHelper";

function ChangeLogPage() {
    const [versions, setVersions] = useState<Array<Version>>([]);

    const { t } = useTranslation();

    const service = new ProductService;

    useEffect(() => {
        service.listVersions().then((data: any) => {
            setVersions(data.body);
        });
    }, []);

    return (
        <>
            <div className="p-3">
                <h1>{t('title.changelog')}</h1>

                {versions.map((version: Version) => (
                    <Card className="changelog-card mb-3">
                        <div className="row g-2 align-items-center">
                            <div className="col-auto">
                                <FaTag size="1.2rem"/>
                            </div>
                            <div className="col">
                                <h3>v{version.name}</h3>
                            </div>
                            <div className="col-auto">
                                <Badge color="gray">{DateHelper.formatDate(version.created_at)}</Badge>
                            </div>
                        </div>
                        {version.changelog === null ? (
                            <i>No details</i>
                        ) : (
                            <ul>
                                {version.changelog.split('\n').map((line: string) => (
                                    <li>{line}</li>
                                ))}
                            </ul>
                        )}
                    </Card>
                ))}
            </div>
        </>
    );
}

export default ChangeLogPage;
